module.exports = __webpack_public_path__ + "static/good-to-great-4c21042b2c7adcba9c562daff4b8ca39.jpg";